import useReviewBaseActions from './useReviewBaseActions'

export default useReviewBaseActions
